import React from "react";
import { CheckCircle2 } from "lucide-react";

// Import local images (place them inside /src/assets or /public/images)
import visionMain from "./Images/v1.jpg";
import visionSmall1 from "./Images/v2.jpg";
import visionSmall2 from "./Images/v3.jpg";

const VisionSection = () => {
  return (
    <section className="bg-[#f4faf5] py-16 px-6 md:px-16">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        {/* Left Content */}
        <div>
          <h2 className="text-3xl md:text-4xl font-extrabold text-green-900 mb-6">
            Our Vision
          </h2>
          <p className="text-gray-700 leading-relaxed mb-8">
            At <strong>Daily Go</strong>, our vision is to revolutionize how
            businesses source their groceries—by blending speed, reliability,
            and technology. We aspire to be the go-to wholesale platform,
            empowering retailers, restaurants, and institutions with effortless
            access to quality products and seamless delivery.
            <br /> <br />
            We believe strong supply chains create stronger businesses. With a
            focus on innovation, affordability, and long-term partnerships,
            we’re shaping the future of wholesale—one order, one region, and one
            relationship at a time.
          </p>

          {/* Bullet Points */}
          <ul className="space-y-5">
            {[
              "Transforming the Wholesale Grocery Landscape",
              "Fueling Business Growth Nationwide",
              "Simplifying Procurement with Technology",
              "Strengthening Communities Through Supply Chains",
            ].map((item, idx) => (
              <li
                key={idx}
                className="flex items-start gap-3 group hover:translate-x-2 transition-transform duration-300"
              >
                <CheckCircle2 className="text-green-600 w-6 h-6 flex-shrink-0 group-hover:scale-110 transition-transform" />
                <span className="font-semibold text-gray-900">{item}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Right Side Images */}
        <div className="grid grid-cols-2 gap-4">
          {/* Main Image */}
          <div className="col-span-2 overflow-hidden rounded-2xl shadow-md">
            <img
              src={visionMain}
              alt="market"
              className="w-full h-72 object-cover transform hover:scale-105 transition duration-500"
            />
          </div>

          {/* Small Images */}
          <div className="overflow-hidden rounded-2xl shadow-md">
            <img
              src={visionSmall1}
              alt="customers"
              className="w-full h-40 object-cover transform hover:scale-105 transition duration-500"
            />
          </div>
          <div className="overflow-hidden rounded-2xl shadow-md">
            <img
              src={visionSmall2}
              alt="grocery"
              className="w-full h-40 object-cover transform hover:scale-105 transition duration-500"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisionSection;
